import React from "react";
import { BuyNowBar } from "../components/BuyNowBar/BuyNowBar";
import { DisclaimerSection } from "../components/DisclaimerSection/DisclaimerSection";
import { PlanInfoSection } from "../components/PlanInfoSection/PlanInfoSection";
import { PrimaryContactSection } from "../components/PrimaryContactSection/PrimaryContactSection";
import { TncSection } from "../components/TncSection/TncSection";
import { TravellerDetailSection } from "../components/TravellerDetailSection/TravellerDetailSection";
import { TripContextHeader } from "../components/TripContextHeader/TripContextHeader";

const WithPadding: (Cmp: React.ComponentType<any>) => React.FC<any> =
  (Cmp) => (props) =>
    (
      <div style={{ padding: "0 16px" }}>
        <Cmp {...props} />
      </div>
    );

export const TRAVELLER_DETAILS_COMPONENT_MAPPER: Record<
  string,
  React.ComponentType<any>
> = {
  COMPONENT_TRAVELLER_ATTRIBUTE_CONTEXT_EDIT: TripContextHeader,
  COMPONENT_MYPARTNER_TRAVELLER_ATTRIBUTE_ITINERARY_INFO: TripContextHeader,
  COMPONENT_MYPARTNER_TRAVELLER_ATTRIBUTE_PLAN_INFO: PlanInfoSection,
  COMPONENT_TRAVELLER_ATTRIBUTE_PAGE_TRAVELLER_DETAIL: WithPadding(
    TravellerDetailSection
  ),
  PRIMARY_CONTACT: PrimaryContactSection,
  COMPONENT_MYPARTNER_TRAVELLER_ATTRIBUTE_TNC: WithPadding(TncSection),
  COMPONENT_MYPARTNER_TRAVELLER_ATTRIBUTE_DISCLAIMER:
    WithPadding(DisclaimerSection),
  COMPONENT_TRAVELLER_ATTRIBUTE_BUYNOW_PRICE_BREAKUP: BuyNowBar,
};

export type TravellerDetailsTemplateId =
  keyof typeof TRAVELLER_DETAILS_COMPONENT_MAPPER;
